import * as React from 'react'

const SchedulingIcon = () => (
  <svg
    width="52"
    height="37"
    viewBox="0 0 52 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.6456 6.42403V10.2433C41.6456 10.2433 1.8149 10.1445 1.00001 10.2433V6.42403C0.998926 6.07026 1.0678 5.71977 1.20268 5.39272C1.33756 5.06567 1.53579 4.76852 1.78594 4.51836C2.0361 4.26821 2.33325 4.06999 2.6603 3.93511C2.98735 3.80023 3.33784 3.73135 3.69161 3.73243H38.954C39.3078 3.73135 39.6583 3.80023 39.9853 3.93511C40.3124 4.06999 40.6095 4.26821 40.8597 4.51836C41.1098 4.76852 41.308 5.06567 41.4429 5.39272C41.5778 5.71977 41.6467 6.07026 41.6456 6.42403Z"
      fill="#005AA3"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6571 32.9036H3.69161C3.33745 32.9036 2.98677 32.8337 2.65968 32.6979C2.33258 32.5621 2.03549 32.3631 1.78545 32.1123C1.5354 31.8615 1.33731 31.5638 1.20253 31.2363C1.06775 30.9088 0.99893 30.5579 1.00001 30.2037V10.2431C1.82313 10.1443 41.6456 10.2431 41.6456 10.2431V30.2037C41.6467 30.5579 41.5779 30.9088 41.4431 31.2363C41.3083 31.5638 41.1102 31.8615 40.8602 32.1123C40.6101 32.3631 40.313 32.5621 39.9859 32.6979C39.6588 32.8337 39.3082 32.9036 38.954 32.9036"
      fill="white"
    />
    <path
      d="M32.6571 32.9036H3.69161C3.33745 32.9036 2.98677 32.8337 2.65968 32.6979C2.33258 32.5621 2.03549 32.3631 1.78545 32.1123C1.5354 31.8615 1.33731 31.5638 1.20253 31.2363C1.06775 30.9088 0.99893 30.5579 1.00001 30.2037V10.2431C1.82313 10.1443 41.6456 10.2431 41.6456 10.2431V30.2037C41.6467 30.5579 41.5779 30.9088 41.4431 31.2363C41.3083 31.5638 41.1102 31.8615 40.8602 32.1123C40.6101 32.3631 40.313 32.5621 39.9859 32.6979C39.6588 32.8337 39.3082 32.9036 38.954 32.9036"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.8183 16.1948H41.6125C41.2125 16.1948 40.8882 16.5191 40.8882 16.9192V18.1292C40.8882 18.5292 41.2125 18.8535 41.6125 18.8535H41.8183C42.2184 18.8535 42.5427 18.5292 42.5427 18.1292V16.9192C42.5427 16.5191 42.2184 16.1948 41.8183 16.1948Z"
      fill="white"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6456 10.2431H1C1.81489 10.1443 41.6456 10.2431 41.6456 10.2431Z"
      fill="white"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.09473 14.7954H9.16514"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9229 14.7954H18.9933"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6436 14.7954H28.714"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.4722 14.7954H38.5426"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.09473 21.2563H9.16514"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9229 21.2563H18.9933"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6436 21.2563H28.714"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.09473 27.7266H9.16514"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9229 27.7266H18.9933"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.6436 27.7266H28.714"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.4722 27.7266H38.5426"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0707 2.44872C12.0707 1.64863 11.4221 1.00003 10.622 1.00003C9.82192 1.00003 9.17331 1.64863 9.17331 2.44872V5.00039C9.17331 5.80047 9.82192 6.44907 10.622 6.44907C11.4221 6.44907 12.0707 5.80047 12.0707 5.00039V2.44872Z"
      fill="white"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.4716 2.44869C33.4716 1.6486 32.823 1 32.0229 1C31.2228 1 30.5742 1.6486 30.5742 2.44869V5.00036C30.5742 5.80044 31.2228 6.44904 32.0229 6.44904C32.823 6.44904 33.4716 5.80044 33.4716 5.00036V2.44869Z"
      fill="white"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.3216 18.1132L48.315 18.1084C48.0183 17.8902 47.601 17.9539 47.3828 18.2505L46.1637 19.9083C45.9456 20.205 46.0092 20.6223 46.3059 20.8404L46.3125 20.8453C46.6091 21.0634 47.0265 20.9998 47.2446 20.7032L48.4637 19.0454C48.6819 18.7487 48.6182 18.3314 48.3216 18.1132Z"
      fill="white"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.1061 20.8403L37.1128 20.8354C37.4094 20.6173 37.4731 20.1999 37.2549 19.9033L36.0358 18.2455C35.8177 17.9489 35.4003 17.8852 35.1037 18.1034L35.097 18.1082C34.8004 18.3264 34.7368 18.7437 34.9549 19.0404L36.174 20.6982C36.3922 20.9948 36.8095 21.0584 37.1061 20.8403Z"
      fill="white"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6457 36.2044C46.6099 36.2044 50.6342 32.1802 50.6342 27.216C50.6342 22.2518 46.6099 18.2275 41.6457 18.2275C36.6815 18.2275 32.6572 22.2518 32.6572 27.216C32.6572 32.1802 36.6815 36.2044 41.6457 36.2044Z"
      fill="#005AA3"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6453 33.8252C45.2957 33.8252 48.2549 30.866 48.2549 27.2156C48.2549 23.5652 45.2957 20.606 41.6453 20.606C37.9949 20.606 35.0356 23.5652 35.0356 27.2156C35.0356 30.866 37.9949 33.8252 41.6453 33.8252Z"
      fill="white"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.3955 27.2158H48.2558"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.0356 27.2158H36.8959"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6455 22.4662V20.606"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6455 33.8173V31.957"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M41.6455 24.7467V27.216H44.9133" fill="white" />
    <path
      d="M41.6455 24.7467V27.216H44.9133"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.0868 14.6885H40.3459C40.0049 14.6885 39.7285 14.9649 39.7285 15.3058V16.2195C39.7285 16.5604 40.0049 16.8368 40.3459 16.8368H43.0868C43.4278 16.8368 43.7042 16.5604 43.7042 16.2195V15.3058C43.7042 14.9649 43.4278 14.6885 43.0868 14.6885Z"
      fill="white"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SchedulingIcon
